import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import sd from "../assets/SubhadipDas.png";
import DarkMode from "./DarkMode";
import { motion } from "framer-motion";
import navItems from "../data/navItems";

const Navbar = (props) => {
  const { toggle } = props;
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const [open, setOpen] = useState("hidden sm:block");
  const [rotate, setRotate] = useState(
    "fa-sharp fa-solid fa-angles-down w-10 text-xl"
  );
  const handleOpen = () => {
    if (open === "hidden sm:block") {
      setOpen("");
      setRotate("fa-sharp fa-solid fa-angles-down w-10 text-xl rotate-180");
    }
    if (open === "") {
      setOpen("hidden sm:block");
      setRotate("fa-sharp fa-solid fa-angles-down w-10 text-xl");
    }
  };
  const navClose = () => {
    setOpen("hidden sm:block");
    setRotate("fa-sharp fa-solid fa-angles-down w-10 text-xl");
  };

  return (
    <div className="pt-3 sticky top-0 z-50">
      <div>
        <nav className="glass sm:h-20 pt-2 pb-3 sm:pt-1 px-4 max-w-full sm:mx-5 mx-4 mt-1 sm:rounded-3xl rounded-xl shadow-soft">
          <div className="sm:flex sm:justify-between sm:items-center pt-2">
            <div
              className="text-slate-900 dark:text-slate-100 sm:text-lg font-bold font-serif text-center flex justify-between items-center space-x-2 select-none no-copy"
              onCopy={(e) => e.preventDefault()}
              onSelectStart={(e) => e.preventDefault()}
            >
              <img
                className="h-10 w-10 sm:h-14 sm:w-14 rounded-full"
                src={sd}
                alt="Subhadip Das"
                loading="lazy"
                decoding="async"
              />
               <Link to="/" className="uppercase select-none no-copy">
                 subhadip das
               </Link>
              <div className="hidden sm:block pl-5">
                <DarkMode toggle={toggle} />
              </div>
              <div className="space-y-1">
                 <div className="hidden sm:block text-slate-700 dark:text-slate-300 pl-3 text-sm font-sans font-medium select-none no-copy">
                   {date.toLocaleDateString("en-US", { day: "numeric" }) +
                     "-" +
                     date.toLocaleDateString("en-US", { month: "short" }) +
                     "-" +
                     date.toLocaleDateString("en-US", { year: "numeric" })}
                 </div>
                 <div className="hidden sm:block text-slate-700 dark:text-slate-300 pl-3 text-sm font-sans font-medium select-none no-copy">
                   {date.toLocaleTimeString()}
                 </div>
              </div>
              <div className="sm:hidden animate-float">
                <i className={rotate} onClick={handleOpen}></i>
              </div>
            </div>
            <div className={`${open} transition-all duration-300 ease-out`}
              >
              <br className="sm:hidden" />
              <hr className="sm:hidden" />
              <div className="text-slate-900 dark:text-slate-100 flex justify-center mt-2 sm:mt-0">
                <ul
                  className="flex flex-wrap justify-between gap-5 sm:gap-0 sm:space-x-6 text-xl sm:text-lg font-semibold sm:overflow-hidden pt-1 sm:pt-0 select-none no-copy"
                  onCopy={(e) => e.preventDefault()}
                  onSelectStart={(e) => e.preventDefault()}
                >
                  {navItems.map((item) => (
                    <li className="cursor-pointer" onClick={navClose} key={item.to}>
                      <motion.span className="select-none no-copy" whileHover={{ y: -2 }} whileTap={{ scale: 0.98 }}>
                        <Link to={item.to}>{item.label}</Link>
                      </motion.span>
                    </li>
                  ))}
                </ul>
              </div>
              <br className="sm:hidden" />
              <hr className="sm:hidden" />
              <div className="flex sm:hidden justify-between items-center pt-4 py-2">
                <div className="text-slate-700 dark:text-slate-300 font-medium text-md select-none no-copy">
                  {date.toLocaleTimeString()}
                </div>
                <div className="pt-4 py-2" onClick={navClose}>
                  <DarkMode toggle={toggle} />
                </div>
                <div className="text-slate-700 dark:text-slate-300 font-medium text-md select-none no-copy">
                  {date.toLocaleDateString("en-US", { day: "numeric" }) +
                    "-" +
                    date.toLocaleDateString("en-US", { month: "short" }) +
                    "-" +
                    date.toLocaleDateString("en-US", { year: "numeric" })}
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
